import { jsx as f } from "react/jsx-runtime";
import p from "react";
import { ui as g } from "../ui.js";
import { clsx as h } from "../../utils/clsx.js";
import '../../assets/Text.css';const $ = "_root_lfxjz_1", k = "_centered_lfxjz_1", z = "_truncated_lfxjz_4", b = "_typographic_lfxjz_12", j = "_block_lfxjz_23", r = {
  root: $,
  centered: k,
  truncated: z,
  typographic: b,
  block: j
}, i = {
  0: 0,
  25: "var(--text-opacity-25)",
  50: "var(--text-opacity-50)",
  75: "var(--text-opacity-75)",
  100: 1
};
function C(o) {
  if ("colorToken" in o)
    return `var(--color-${o.colorToken})`;
  const {
    color: t = "main",
    opacity: e = 1
  } = o, c = t === "main" ? "950" : "pure", a = c === "pure" ? `--color-${t}` : `--color-${t}-${c}`, n = i[e] || i[100];
  return `rgba(var(${a}), ${n})`;
}
const w = p.forwardRef(function(t, e) {
  const {
    family: c = "primary",
    size: a = "normal",
    weight: n = "normal",
    asDiv: l = !1,
    centered: m = !1,
    truncated: u = !1,
    typographic: _ = !1,
    uppercase: x = !1,
    userSelectable: d = !1,
    children: y,
    className: v
  } = t, T = h(r.root, v, {
    [r.block]: l,
    [r.centered]: m,
    [r.truncated]: u,
    [r.typographic]: _,
    [g.cls.userSelectableText]: d
  }), s = {
    color: C(t),
    fontFamily: `var(--font-family-${c})`,
    fontSize: `var(--font-size-${a})`,
    fontWeight: `var(--font-weight-${n})`
  };
  return x && (s.textTransform = "uppercase"), // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /* @__PURE__ */ f(l ? "div" : "span", { ref: e, dir: "auto", className: T, style: s, children: y });
}), D = p.forwardRef(function(t, e) {
  return /* @__PURE__ */ f(w, { ref: e, ...t, asDiv: !0 });
});
export {
  i as TEXT_OPACITY_MAP,
  w as Text,
  D as TextBlock
};
